import { css } from '@emotion/css';

import { CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR } from '@/modules/corporate/modules/questions/fields/components/Player/OptionsListItem/styles';

export const checkboxStyles = css`
  background-color: var(--bg-primary);
  border-color: var(--interactive-border);
  color: var(--icon-placeholder);

  &:hover {
    border-color: ${CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR};
    color: ${CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR};
  }

  &.Mui-checked {
    background-color: ${CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR};
    border-color: ${CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR};
    color: var(--icon-white);

    &:hover {
      background-color: ${CORRECT_OPTION_KEY_CODE_BACKGROUND_COLOR};
    }
  }

  &.Mui-disabled {
    opacity: 0.5;
  }
`;

export const deleteActionDisabledStyles = css`
  &.Mui-disabled {
    opacity: 0;
  }
`;
